/* eslint-disable react-refresh/only-export-components */
// import GuestLayout from "@/layouts/GuestLayout";

// import CostEstimatorResult from "@/pages/CostEstimatorResult";
import ErrorPage from "@/pages/Error";
// import GuestAppLoader from "@/layouts/GuestAppLoader";
// import RequireAuth from "@/pages/RequireAuh";
// import validateToken from "@/services/validator";
// Removed the import for GuestLayout due to the error
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  redirect,
} from "react-router-dom";
import Group from "@/pages/group";
import Disclaimer from "@/pages/disclaimer";
import Login from "@/pages/login";
import AccountReset from "@/pages/account-reset";
import Verification from "@/pages/verification";
import Home from "@/pages/home";
import MainLayout from "@/layouts/main-layout";
import NotificationPage from "@/pages/notification";

import CareHistory from "@/pages/care-history";
import SpendSummary from "@/pages/spend-summary";

import Service from "@/pages/services";
import IDCard from "@/pages/id-card";
import MyBenefit from "@/pages/my-benefit";
import Locate from "@/pages/locate";

import OpenContainer from "@/pages/open-container";

// import { ScreeRouteNames } from "@/constants";
import ScreenRouteNames from "@/constants/screen-route-names";

import RequireGroup from "@/pages/containers/require-group";
import RequireAuth from "@/pages/containers/require-auth";
import useAuth, { AuthMode, AuthProvider } from "@/context/auth-provider";
import { queryClient } from "@/hooks/use-query-client";

import Biometrics from "@/pages/biometrics";

import MyAccount from "@/pages/components/my-account/editAccount-enable";

import VerifyOtp from "@/pages/verify-otp";
import CostEstimator from "@/pages/cost-estimator";
import CostEstimatorResult from "@/pages/cost-estimator-results";
import ProviderSearch from "@/pages/provider-search";
import ProviderSearchResult from "@/pages/provider-search-result";
import MfaLogin from "@/pages/mfa-login";
import Error404 from "@/pages/error/404";

import Survey from "@/pages/survey";

import BalanceBill from "@/pages/balance-bill";
import { QueryKeys, STORAGE, STORAGE_KEY } from "@/constants";
import SessionExpiredPage from "@/pages/error/session-expired";
import AccessDeniedPage from "@/pages/error/access-denied";
import { getItem, setItem } from "@/lib/storage-utils";
import { loadGroupDataFromCache } from "@/lib/load-cache-data";
import { lowerCaseComparison } from "@/lib/string-util";
import { useRouteLogger } from "@/services/logger/logger-hooks";
import RegisterContainer from "@/pages/register/register-container";
import { validateGroupId } from "@/services/group";
import CsrChat from "@/pages/components/csr-chat/CsrChat";
import { HcbbCostEstimatorSearchPage } from "@/pages/hcbb-cost-estimator/hcbb-cost-estimator-search";
import { HcbbCostEstimatorResultPage } from "@/pages/hcbb-cost-estimator/hcbb-cost-estimator-result";
import { HcbbFacilityDetailPage } from "@/pages/hcbb-cost-estimator/hcbb-facility-detail";
import { HcbbProviderDetailPage } from "@/pages/hcbb-cost-estimator/hcbb-provider-detail";
import Videos from "@/pages/videos";
import { RouteAnnouncer } from "@/components/route-announcer";

const AppLayout = () => {
  // TODO: MAYBE NEED TO HANDLE DIFFERENTLY FOR GUEST_LOGIN (SEND memberID in username for guest login BUT NOT SENT IN PAYLOAD .. DO WE HANDLE IT IN INTERCEPTOR ??)
  useRouteLogger();

  return (
    <>
      {/*
        Mounted above every route so all of them get:
        - a skip link (WCAG 2.4.1 Bypass Blocks — A),
        - a unique document.title (WCAG 2.4.2 Page Titled — A),
        - a polite route-change announcement (WCAG 4.1.3 Status Messages — AA).
        None of these existed anywhere in the app before.
      */}
      <RouteAnnouncer />
      <Outlet />
    </>
  );
};

const RequireCsrChat: React.FC = () => {
  const { authData } = useAuth();
  const isMember = authData?.mode === AuthMode.MEMBER;
  const showChat = Boolean(
    (
      queryClient.getQueryData([
        QueryKeys.GLOBAL_FLAGS,
        authData?.user?.username,
      ]) as { data?: Array<{ showChat?: boolean }> }
    )?.data?.[0]?.showChat,
  );

  if (!isMember || !showChat) {
    return <Navigate to={`/${ScreenRouteNames.LOGIN.path}`} replace />;
  }

  return <CsrChat />;
};

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: (
        <RequireGroup>
          <AppLayout />
        </RequireGroup>
      ),
      children: [
        {
          element: <OpenContainer />,
          loader: async ({ request }) => {
            //Reading from session storage only becayse we have no access {authdata} from useAuth hook in open container
            const sessionUserData = JSON.parse(
              window.sessionStorage.getItem(STORAGE_KEY.AUTH_DATA) || "{}",
            );

            const url = new URL(request.url);
            // console.log("SessionTest open container loader", { url, sessionUserData });
            if (
              sessionUserData?.user &&
              lowerCaseComparison(sessionUserData?.mode, AuthMode.MEMBER)
            ) {
              const publicPaths = [
                ScreenRouteNames.ROOT.path,
                ScreenRouteNames.DISCLAIMER.path,
                ScreenRouteNames.LOGIN.path,
                ScreenRouteNames.REGISTER.path,
                ScreenRouteNames.ACCOUNT_RESET.path,
              ];
              if (publicPaths.some((path) => url.pathname.includes(path))) {
                //redirect() used here as this handles before component rendering. this is better than using useNavigate().
                return redirect(`/${ScreenRouteNames.HOME.path}`);
              }
            }

            await loadGroupDataFromCache();

            return null;
          },
          children: [
            {
              index: true,
              loader: async ({ request }) => {
                const url = new URL(request.url);
                const groupCode = url.searchParams.get("code");

                if (groupCode) {
                  const response = await validateGroupId(groupCode);
                  if (response?.data?.values) {
                    setItem(
                      STORAGE_KEY.CACHED_GROUP_DETAIL,
                      {
                        groupId: response.data.values.entered_id,
                        agreement: true,
                      },
                      STORAGE.LOCAL,
                    );

                    setItem(
                      STORAGE_KEY.GROUP_DATA,
                      {
                        ...response.data.values,
                        registrationFieldsLookup: response.registrationFields,
                      },
                      STORAGE.SESSION,
                    );
                    await loadGroupDataFromCache();
                    return redirect(`/${ScreenRouteNames.LOGIN.path}`);
                  }
                }

                const cachedGroupDetail = getItem(
                  STORAGE_KEY.CACHED_GROUP_DETAIL,
                  STORAGE.LOCAL,
                );
                if (
                  Boolean(cachedGroupDetail?.groupId) &&
                  cachedGroupDetail?.agreement
                ) {
                  return redirect(`/${ScreenRouteNames.LOGIN.path}`);
                }
                if (
                  Boolean(cachedGroupDetail?.groupId) &&
                  !cachedGroupDetail?.agreement
                ) {
                  return redirect(`/${ScreenRouteNames.DISCLAIMER.path}`);
                }
                if (cachedGroupDetail?.groupId) {
                  await loadGroupDataFromCache();
                }

                return null;
              },
              element: <Group />,
            },
            {
              path: ScreenRouteNames.DISCLAIMER.path,
              element: <Disclaimer />,
            },
            {
              path: ScreenRouteNames.LOCATE.path,
              element: <Locate />,
            },
            {
              path: ScreenRouteNames.LOGIN.path,
              element: (
                <AuthProvider>
                  <Login />
                </AuthProvider>
              ),
            },
            {
              path: ScreenRouteNames.REGISTER.path,
              element: <RegisterContainer />,
            },
            {
              path: ScreenRouteNames.ACCOUNT_RESET.path,
              element: <AccountReset />,
            },
            {
              path: ScreenRouteNames.VERIFICATION.path,
              element: <Verification />,
            },
            {
              path: ScreenRouteNames.VERIFY_OTP.path,
              element: <VerifyOtp />,
            },
          ],
        },
        {
          path: ScreenRouteNames.MFA_LOGIN.path,
          element: (
            <AuthProvider>
              <MfaLogin />
            </AuthProvider>
          ),
        },
        {
          element: (
            <AuthProvider>
              <RequireAuth>
                <MainLayout />
              </RequireAuth>
            </AuthProvider>
          ),
          children: [
            {
              // index: true,
              path: ScreenRouteNames.HOME.path,
              element: <Home />,
            },
            {
              path: ScreenRouteNames.NOTIFICATION.path,
              element: <NotificationPage />,
            },
            {
              path: ScreenRouteNames.CARE_HISTORY.path,
              element: <CareHistory />,
            },
            {
              path: ScreenRouteNames.ID_CARD.path,
              element: <IDCard />,
            },
            {
              path: ScreenRouteNames.BIOMETRICS.path,
              element: <Biometrics />,
            },
            // {
            //   path: ScreenRouteNames.MY_PCP.path,
            //   element: <MyPcp />,
            // },
            {
              path: ScreenRouteNames.MY_ACCOUNT.path,
              element: <MyAccount />,
            },

            {
              path: ScreenRouteNames.MY_BENEFIT.path,
              element: <MyBenefit />,
            },

            {
              path: ScreenRouteNames.SPEND_SUMMARY.path,
              element: <SpendSummary />,
            },

            {
              path: ScreenRouteNames.SERVICE.path,
              element: <Service />,
            },
            {
              path: ScreenRouteNames.PROVIDER_SEARCH_BY_GROUP.path,
              element: <ProviderSearch />,
            },
            {
              path: `${ScreenRouteNames.PROVIDER_SEARCH_BY_GROUP.path}/${ScreenRouteNames.PROVIDER_SEARCH_RESULT.path}`,
              element: <ProviderSearchResult />,
            },
            {
              path: ScreenRouteNames.COST_ESTIMATOR.path,
              element: <CostEstimator />,
              // children: [
              //   {
              //     path: ScreeRouteNames.COST_ESTIMATOR_RESULT,
              //     element: <CostEstimatorResult />,
              //   },
              // ],
            },
            {
              path: ScreenRouteNames.HCBB_COST_ESTIMATOR.path,
              element: <HcbbCostEstimatorSearchPage />,
            },
            {
              path: `${ScreenRouteNames.HCBB_COST_ESTIMATOR.path}/${ScreenRouteNames.HCBB_COST_ESTIMATOR_RESULT.path}`,
              element: <HcbbCostEstimatorResultPage />,
            },
            {
              path: `${ScreenRouteNames.HCBB_COST_ESTIMATOR.path}/${ScreenRouteNames.HCBB_COST_ESTIMATOR_RESULT.path}/${ScreenRouteNames.HCBB_FACILITY_DETAIL.path}`,
              element: <HcbbFacilityDetailPage />,
            },
            {
              path: `${ScreenRouteNames.HCBB_COST_ESTIMATOR.path}/${ScreenRouteNames.HCBB_COST_ESTIMATOR_RESULT.path}/${ScreenRouteNames.HCBB_PROVIDER_DETAIL.path}`,
              element: <HcbbProviderDetailPage />,
            },
            {
              path: `${ScreenRouteNames.COST_ESTIMATOR.path}/${ScreenRouteNames.COST_ESTIMATOR_RESULT.path}`,
              element: <CostEstimatorResult />,
            },
            {
              path: `${ScreenRouteNames.SURVEY.path}`,
              element: <Survey />,
            },
            {
              path: `${ScreenRouteNames.BALANCE_BILL.path}`,
              element: <BalanceBill />,
            },
            {
              path: `${ScreenRouteNames.CSR_CHAT.path}`,
              element: <RequireCsrChat />,
            },
            {
              path: `${ScreenRouteNames.VIDEOS.path}`,
              element: <Videos />,
            },
          ],
        },
      ],
      errorElement: <ErrorPage />,
    },

    {
      path: "*",
      element: <Error404 />,
    },
    {
      path: ScreenRouteNames.ERROR.path,
      element: <ErrorPage />,
    },
    {
      path: ScreenRouteNames.ACCESS_DENIED.path,
      element: <AccessDeniedPage />,
    },
    {
      path: ScreenRouteNames.SESSION_EXPIRED.path,
      element: <SessionExpiredPage />,
    },
  ],
  { hydrateFallbackElement: null },
);

/**
 * in the context of your React Router configuration, the path: "/" within the nested route structure has a specific role. Let's break down the difference between using it and commenting it out:
Using path: "/"
When you specify path: "/" in a nested route, it means that this route will match the root path of the parent route. In your case, the parent route is also "/", so this nested route will match the root path of your application. The GuestLayout component will be rendered at the root path, and its children will be rendered based on their respective paths.
Commenting path: "/"
If you comment out path: "/", the nested route will not have a specific path to match. This means that the GuestLayout component will not be rendered at the root path. Instead, the router will look for other routes that match the root path or any other specified paths.
 */
export default router;
